import { Link } from "react-router-dom";
import strips from "../assets/strips.png";
import bounce from "../assets/bounce.png";
import landing_image from "../assets/landing_image.png";
import { useContext } from "react";
import { AppContext } from "../context/context";

function HeroSection() {
  const { setState } = useContext(AppContext);

  return (
    <div
      id="home"
      className="relative w-full h-fit md:h-[650px] xl:h-[800px] xxl:h-screen lxl:max-h-[1000px] pt-20 smd:pt-24 pb-8 md:pb-0 md:pt-0"
    >
      <img
        src={strips}
        className="absolute top-0 smd:top-[-100px] xxl:top-[-200px] left-[-100px ] w-[80%]"
        alt="landig-strips"
        onLoad={() => {
          setState((ps) => ({ ...ps, loadedImages: ps.loadedImages + 1 }));
        }}
      />

      <div className="md:absolute m-auto md:flex w-[300px] smd:w-[400px] md:w-[48%] top-24 md:top-28 lxl:top-32 right-4 lg:right-6 xl:right-12 xxl:right-16">
        <div className="relative w-full h-fit">
          <img
            src={bounce}
            className="absolute w-[38%] animate-bounce-slow top-0.5 md:top-2"
            alt="bouncing_image"
            onLoad={() => {
              setState((ps) => ({ ...ps, loadedImages: ps.loadedImages + 1 }));
            }}
          />
          <img
            src={landing_image}
            className="w-fit"
            alt="landing_image"
            onLoad={() => {
              setState((ps) => ({ ...ps, loadedImages: ps.loadedImages + 1 }));
            }}
          />
        </div>
      </div>

      <div className="md:absolute w-full top-20 smd:left-6 lxl:left-2 xl:top-24 lxl:top-28 md:w-1/2 h-fit flex flex-col gap-8 xxl:pl-32 lxl-pl-40 xxl:pr-10 lxl:pr-16 p-8 md:pt-14 xxl:pt-16 lxl:pt-36 lg:pt-32">
        <h6 className="max-w-[650px] text-[22px] smd:text-[28px] md:text-[32px] xl:text-[40px] lxl:text-[48px] font-bold leading-tight text-center md:text-left">
          Streamline Your{" "}
          <span className="text-purp">Employee Management </span> and{" "}
          <span className="text-purp">Rostering </span>
          with <span className="text-teal">SynapsivateHRM</span>
        </h6>

        <p className="text-sm smd:text-base lg:text-xl font-semibold w-full md:max-w-[600px] text-center md:text-left">
          Effortlessly manage employees, employee shifts, leaves and events with
          our intuitive employee management app. Simplify your work, amplify
          your productivity and automate your rostering.
        </p>

        <div className="w-full flex gap-8 justify-center md:justify-start xxl:mt-10 font-semibold">
          <Link
            to="/hrm/signup"
            className="w-[150px] flex justify-center items-center xxl:w-[180px] h-10 xxl:h-12 bg-purp hover:bg-teal text-white rounded-lg duration-500 whitespace-nowrap"
          >
            Get Started
          </Link>
          <button
            onClick={() => setState((ps) => ({ ...ps, showDemo: true }))}
            className="w-[150px] xxl:w-[180px] h-10 xxl:h-12 border hover:text-white border-purp hover:border-teal hover:bg-teal rounded-lg duration-500 whitespace-nowrap"
          >
            Watch Demo
          </button>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;
